<template>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="35%" center :before-close="handleClose">
        <el-form ref="custForm" :model="formData">
            <template v-for="item in configFormData">
                <el-form-item label=" " v-if="!item.isShow" :key="item.key" :prop="item.key"
                    :rules="[{ required: item.required, message: '该项为必填项', trigger: item.trigger }]">

                    <div class="label" v-show="!item.isShow">{{ item.label }}</div>
                    <el-input style="width: 300px;" size="mini" v-if="item.type == 'input'"
                        v-model="formData[item.key]"></el-input>

                    <el-select v-model="formData[item.key]" size="mini" :multiple="item.multiple" @change="getChange(item)"
                        v-if="item.type == 'select'" :placeholder="item.placeholder" style="width: 300px;">
                        <el-option v-for="ele in item.child" :key="ele.value" :label="ele.label" :value="ele.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </template>
        </el-form>
        <el-button type="primary" @click="saveUpdateByid">保存</el-button>
    </el-dialog>
</template>

<script>
import { configFormData } from './index.js'
import fetch from '@/api/fetch'

export default {
    name: 'examDialog',

    data() {
        return {
            configFormData,
            formData: {
                professionId: '',
                schemeId: '',
                // sex: '',
                // color: '',
                // pwd: '',
                // time: '',
                // sport: []
            },
        };
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default() {
                return false
            }
        },
        rowData: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    watch: {
        rowData: {
            handler(val) {
                this.formData = {
                    professionId: val.professionId,
                    schemeId: val.schemeId
                }

                this.getProfesionlist()

            },
            deep: true
        }
    },

    mounted() {
        // this.getProfesionlist()

    },

    methods: {
        handleClose() {
            this.$emit('changeDialogVisible', false)
        },
        getChange(item) {
            console.log(item)
            if (item.key == 'professionId') {
                this.getPlanlist(this.formData.professionId)
                this.formData.schemeId = ''
            }
        },
        getPlanlist(id) {
            fetch.getPlanlist({ professionId: id }).then(res => {
                if (res.code == '0') {
                    let item = this.configFormData.find(item => item.key == 'schemeId')
                    item.child = res.data.map(item => {
                        return { ...item, value: item.id, label: item.schemeName }
                    })
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getProfesionlist() {
            return new Promise((resolve, reject) => {
                fetch.getProfesionlist({}).then(res => {
                    if (res.code == '0') {
                        console.log(res)
                        let item = this.configFormData.find(item => item.key == 'professionId')
                        item.child = res.data.map(item => {
                            return { ...item, value: item.id, label: item.name }
                        })
                        console.log(this.formData.professionId)
                        if (this.formData.professionId) {
                            this.getPlanlist(this.formData.professionId)
                        }
                        resolve()
                    } else {
                        this.$message.error(res.msg)
                        reject()
                    }
                })
            })
        },
        saveUpdateByid() {
            this.$refs.custForm.validate((valid) => {
                if (valid) {
                    fetch.saveUpdateByid({
                        id: this.rowData.id,
                        profeesionId: this.formData.professionId,
                        schemeId: this.formData.schemeId
                    }).then(res => {
                        if (res.code == '0') {
                            this.$message.success(res.msg || '保存成功')
                            this.$emit('changeDialogVisible', false)
                        } else {
                            this.$message.error(res.msg || '保存失败')
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.form {
    width: 400px;
    height: auto;
}

/deep/ .el-form-item__content {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .label {
        width: 65px;
        text-align: right;
        margin-right: 10px;
    }
}

/deep/.el-form-item__label {
    padding-right: 0px;
}

/deep/ {
    .el-dialog__body {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
}
</style>